import { walletService } from "@/common/api.service";

const initialStates = {
    status: 'loading',
    walletSettlementList: [],
    showStatus: null
}
const mutations = {
    fetchWalletSettlementList(state , data) {
        state.walletSettlementList = data
    },
    fetchSettlementAyande(state, data) {
        state.showStatus = data.status
    }
}
const getters = {
    wallet_settlement_list: (state) => state.walletSettlementList,
    get_status: (state) => state.showStatus
}
const actions = {
    fetchWalletSettlementList({commit},hashid) {
        return walletService.fetchSettlementAyande(hashid).then(response => {
            commit('fetchWalletSettlementList', response.data.data)
        })
    },
    fetchSettlementAyande({commit},hashid) {
        return walletService.getSettlementDetailAyande(hashid).then(response => {
            commit('fetchSettlementAyande',response.data.data)
        })
    },
    fetchWalletTransaction({commit},hashid) {
        return walletService.fetchWalletTransaction(hashid)
    },
    fetchWalletSettlementData({commit},hashid) {
        return walletService.fetchWalletSettlementData(hashid)
    }
}


export default {
    namespaced: true,
    initialStates,
    mutations,
    getters,
    actions
}